export default class Accordion {
  constructor($el) {
    this.activeClass = 'is-active';
    this.$accordions = document.querySelectorAll('.js-accordion');

    this.$accordions.forEach(($accordion) => {
      const $sections = $accordion.querySelectorAll('.js-accordion-section');
      const $auxiliaryContent = $accordion.querySelectorAll('.js-accordion-auxiliary-content');

      $sections.forEach(($section, index) => {
        const $button = $section.querySelector('.js-accordion-button');
        const $content = $section.querySelector('.js-accordion-content');

        $button.addEventListener('click', () => {
          $section.classList.toggle(this.activeClass);
          $content.setAttribute('aria-expanded', $section.classList.contains(this.activeClass));

          $sections.forEach(($aSection) => {
            if ($aSection !== $section) {
              $aSection.classList.remove(this.activeClass);
            }
          });

          $auxiliaryContent.forEach(($auxiliary) => {
            $auxiliary.classList.remove(this.activeClass);
          });

          if ($auxiliaryContent[index]) {
            $auxiliaryContent[index].classList.add(this.activeClass);
          }
        });
      });
    });
  }
}
